import type { SubscriptionPaymentPhase } from './useSubscribeWithStars';

export const PAYMENT_PHASE_CTA: Record<SubscriptionPaymentPhase, string> = {
  idle: 'Subscribe',
  creatingCheckout: 'Starting...',
  waitingInvoice: 'Preparing...',
  openingInvoice: 'Telegram opened',
  confirmingSubscription: 'Activating...',
  awaitingConfirmation: 'Processing',
  confirmationNeedsSupport: 'Contact support',
};
